<template>
  <div>
    <h1>Error</h1>
    <p>An error occurred while processing the request.</p>
    <pre>{{message}}</pre>
  </div>
</template>

<script>
export default {
  name: 'error',
  computed: {
    message () {
      return this.$route.params.message
    }
  }
}
</script>


// WEBPACK FOOTER //
// ErrorMsg.vue?95b6c08e